export default __webpack_public_path__ + "static/media/elemental-ui.623789ca.svg";